var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    strokeWidth: 2,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 23 2 12 13 1",
    stroke: "#000",
    strokeLinecap: "round"
  })));
};
export { SvgLeftArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjQiIHN0cm9rZS13aWR0aD0iMiIgdmlld0JveD0iMCAwIDE0IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHJvbGU9InByZXNlbnRhdGlvbiIgYXJpYS1oaWRkZW49InRydWUiPgogIDxwYXRoIGQ9Ik0xMyAyM0wyIDEyTDEzIDEiIHN0cm9rZT0iYmxhY2siICBzdHJva2UtbGluZWNhcD0icm91bmQiIC8+Cjwvc3ZnPg==";